import { Element, useNode } from '@craftjs/core';
import { Box, Divider } from '@mui/material';

import { useIsBlockEditorEditMode } from '../BlockEditor.context';
import { ALLOWED_TYPES, BLOCK_DISPLAY_NAMES } from '../blockEditor.types';
import { BlockEditorCanvasContainer } from '../BlockEditorCanvasContainer/BlockEditorCanvasContainer';

export interface TwoColumnLayoutProps {
  leftWidth?: string;
  rightWidth?: string;
  columnGap?: number;
  showDivider?: boolean;
  children?: React.ReactNode;
}

export function TwoColumnLayout({
  leftWidth = '50%',
  rightWidth = '50%',
  columnGap = 4,
  showDivider = false,
}: TwoColumnLayoutProps) {
  const {
    connectors: { connect },
  } = useNode();
  const isEditMode = useIsBlockEditorEditMode();

  return (
    <Box
      ref={(ref: HTMLDivElement | null) => {
        if (ref && isEditMode) connect(ref);
      }}
      sx={{
        display: 'flex',
        gap: columnGap,
        width: '100%',
        ...(showDivider && { flex: 1, minHeight: 0 }),
      }}
    >
      <Box
        sx={{
          width: leftWidth,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Element
          id="leftColumn"
          is={BlockEditorCanvasContainer}
          canvas
          custom={{
            allowedTypes: ALLOWED_TYPES.containerContent,
          }}
        />
      </Box>
      {showDivider && (
        <Divider
          orientation="vertical"
          flexItem
          sx={{ borderColor: 'divider' }}
        />
      )}
      <Box
        sx={{
          width: rightWidth,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Element
          id="rightColumn"
          is={BlockEditorCanvasContainer}
          canvas
          custom={{
            allowedTypes: ALLOWED_TYPES.containerContent,
          }}
        />
      </Box>
    </Box>
  );
}

TwoColumnLayout.craft = {
  displayName: BLOCK_DISPLAY_NAMES.TwoColumnLayout,
  props: {
    leftWidth: '50%',
    rightWidth: '50%',
    columnGap: 4,
    showDivider: false,
  },
};
